import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import { UserserviceService } from '../userservice.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpRequest, HttpEvent, HttpParams } from '@angular/common/http';
@Component({
  selector: 'app-forgetpassword',
  templateUrl: './forgetpassword.component.html',
  styleUrls: ['./forgetpassword.component.scss']
})
export class ForgetpasswordComponent implements OnInit {

  public formControl = new FormControl();
  Registerform!:FormGroup; //for student
  Registerform1!:FormGroup; //for board 
  submitted = false;
  setpasswordforstudent!: boolean;
  user!: string;
  proccessing:boolean=false;
  allfeesdata: any;
  submitted1!: boolean;
  //Registerform: any;
   constructor(private service:UserserviceService ,public router: Router,private httpClient: HttpClient,private route: ActivatedRoute,private formBuilder: FormBuilder) 
   { 
    this.Registerform = formBuilder.group({       
      standard:['',Validators.required],
      application_type:['',Validators.required],     
      email_address:['',[Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
    })
    this.Registerform1 = formBuilder.group({       
      email_address:['',[Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
    })
   
    this.route.params.subscribe(params => {
       this.user = String(params['user']);
      if(this.user=="student"){
        this.setpasswordforstudent=true;
      }   
      else{
        this.setpasswordforstudent=false;
      }  
    });
  }
  get f() { return this.Registerform.controls; }
  get b() { return this.Registerform1.controls; }
  
  ngOnInit(): void {
    if(sessionStorage.getItem('loggeduser')){
      alert("You are already logged in");
      this.router.navigate(['/dashboard']);
    }
    this.getallapplications();
    // window.location.reload();
    // sessionStorage.setItem('loggeduser','newentry');
  //this.getAllDatafromAPI();   
  }
  
resetpassword(regform:any){
  let c = confirm("Are you sure you want to reset password??");
  if(c==true){      
          this.proccessing=true;
          if(this.user=="student"){
              this.submitted = true;
              if (this.Registerform.invalid) {
                alert("Please Fill all details");    
                  return;
              }
                let loginuserdetail:{standard:any,application_type:any,email_address:any,userrole:any}
                ={    
                  standard:regform.standard,
                  application_type:regform.application_type,    
                  email_address:regform.email_address,
                  userrole:this.user
                };
                  this.service.post('/Student_module/resetpassword',loginuserdetail).subscribe((res:any)=>{
                          // console.log(res);
                          if(res.status=="success"){
                            this.proccessing=false;
                            setTimeout(()=>{                           
                              alert(res.Data);
                              window.location.reload();
                              this.router.navigate(['/Login']);
                            }, 500);
                          }
                          else if(res.status=="failed"){
                            this.proccessing=false;
                              setTimeout(()=>{                          
                                alert(res.Data);
                                window.location.reload();
                              }, 500);
                            
                          }                
                  });
          }   
          else{
                this.submitted1 = true;
                if (this.Registerform1.invalid) {
                  alert("Please Fill all details");    
                    return;
                }
                let loginuserdetail:{email_address:any,userrole:any}
                ={    
                  userrole:this.user, 
                  email_address:regform.email_address
                };
                  this.service.post('/Student_module/resetpassword',loginuserdetail).subscribe((res:any)=>{
                        if(res.status=="success"){
                          this.proccessing=false;
                          setTimeout(()=>{                           
                            alert(res.Data);
                            this.router.navigate(['/Login']);
                            window.location.reload();
                          }, 500);
                        }
                        else if(res.status=="failed"){
                          this.proccessing=false;
                            setTimeout(()=>{                          
                              alert(res.Data);
                              window.location.reload();
                            }, 500);
                          
                        }            
                  });
          }    

  }//confirm end  
}

  // verify(){
  //   alert('Please check your email for verification code');
  // }
  getallapplications(){
    this.service.post('/Boardadmin_module/getallapplicationsfees',{}).subscribe((res:any)=>{
     // console.log(res.Data)
     if(res.status=="success"){
         this.allfeesdata=res.Data;
        }
        else{
           alert("Something went wrong!, please refresh page.");
           window.location.reload();
        }
     });
  
  }
}
